/**
 * 患者相关接口
 */

import request from "@/utils/request";

// 获取患者信息
export function getPatientInfo(id) {
    return request({
        url: `/patient/patient-infor/${id}`,
        method: "get"
    })
}

// 保存患者基本信息（id为0时新增，否则修改）
export function savePatientInfo(data) {
    return request({
        url: "/patient/save-patient-infor",
        method: "post",
        data
    })
}

// 获取患者列表信息
export function getPatientList(data) {
    return request({
        url: "/patient/patient-list",
        method: "post",
        data,
    })
}

// 获取历史病历
export function getHistoryOrderMain(data) {
    return request({
        url: "/patient/opd-history-order-main",
        method: "post",
        data
    })
}

// 获取患者标签列表
export function getPatientTagList() {
    return request({
        url: "/patient/pian-yu",
        method: "get"
    })
}

// 保存患者标签
export function savePatientTags(data) {
    return request({
        url: "/patient/pian-yu-data",
        method: 'post',
        data
    })
}

// 获取外部历史病例列表
export function getOutHistoryList(data) {
    return request({
        url: "/opd-input-order/patient-list",
        method: 'post',
        data
    })
}

// 获取外部历史病例详情
export function getOutHistoryDetail(num) {
    return request({
        url: `/opd-input-order/patient-info/${num}`,
        method: 'post',
    })
}

// 获取外部历史病例数量
export function getOutCount() {
    return request({
        url: "/opd-input-order/patient-info-count",
        method: 'post'
    })
}